import {
  useDashboardPeriodFetch,
  useDashboardPeriodParams,
  type DashboardPeriodFetchState,
} from './useDashboardPeriod'
import type { RangeKey } from '@dataTypes/dashboard.types'
import {
  getRecareOverview,
  type RecareOverviewResult,
} from '@services/api/dashboard/recare.api'

export function useRecareOverview(
  range: RangeKey,
  date: string,
  enabled = true,
  queued = false,
): DashboardPeriodFetchState<RecareOverviewResult> {
  const queryParams = useDashboardPeriodParams(range, date)
  return useDashboardPeriodFetch(queryParams, getRecareOverview, {
    enabled,
    queued,
  })
}
